<template>
  <div class="PlayerFullscreenPublic">
    <player-public />
  </div>
</template>

<script>
export default {
  name: "PlayerFullscreenPublic",
  components: {
    PlayerPublic: () => import("@/components/DWorkflowPlayer/player/PlayerPublic.vue"),
  },
};
</script>

<style lang="scss" scoped>
.PlayerFullscreenPublic {
  position: fixed;
  inset: 0;
  background: #242527;
}
</style>
